export default angular
  .module("PublishJavascriptCtrl", ["ui.bootstrap"])
  .controller("PublishJavascriptController", [
    "$scope",
    "$modalInstance",
    function (
      $scope,
      $modalInstance,
    ) {
      $scope.version = {};
      $scope.publish = () => {
        const isCommentField = $scope.versionForm.comment.$viewValue.trim().length > 0;
        if (isCommentField) {
          $modalInstance
            .close({ action: "publish", payload: $scope.version });
        }
      };

      $scope.cancel = () => {
        $modalInstance
          .dismiss({ action: "cancel", payload: $scope.version });
      };
    },
  ]);
